import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']

import * as Customer from '@/services/rest-api/lib/customer/customer'
import * as Vendor from '@/services/rest-api/lib/vendor/vendor'
import * as Address from '@/services/rest-api/lib/delivery/address'

export const tableFilterFields = {
  computed: {
    tableFilterFields() {
      return [
        {
          name: 'created_on',
          isShow: true,
          label: this.$t('global.field.createdDate'),
          type: 'date-picker',
          datepickerType: 'datetime',
          valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
          format: 'DD MMM YYYY HH:mm',
          titleFormat: 'DD MMM YYYY',
          rangeSeparator: ' - ',
          range: true,
          confirm: true,
          confirmText: 'Terapkan',
          disabledDate: (date) => {
            return date > new Date()
          },
          shortcuts: [
            {
              text: this.$t('global.time.today'),
              onClick: () => {
                const startDate = new Date()
                const endDate = new Date()
      
                startDate.setHours(0, 0, 0)
                endDate.setHours(23, 59, 59)
      
                return [startDate, endDate]
              },
            },
            {
              text: this.$t('global.time.yesterday'),
              onClick: () => {
                const startDate = new Date()
                const endDate = new Date()
      
                startDate.setDate(startDate.getDate() - 1)
                startDate.setHours(0, 0, 0)
      
                endDate.setDate(endDate.getDate() - 1)
                endDate.setHours(23, 59, 59)
      
                return [startDate, endDate]
              },
            },
            {
              text: this.$t('global.time.last3Days'),
              onClick: () => {
                const startDate = new Date()
                const endDate = new Date()
      
                startDate.setDate(startDate.getDate() - 3)
                startDate.setHours(0, 0, 0)
                endDate.setHours(23, 59, 59)
      
                return [startDate, endDate]
              },
            },
            {
              text: this.$t('global.time.last7Days'),
              onClick: () => {
                const startDate = new Date()
                const endDate = new Date()
      
                startDate.setDate(startDate.getDate() - 7)
                startDate.setHours(0, 0, 0)
                endDate.setHours(23, 59, 59)
      
                return [startDate, endDate]
              },
            },
          ],
        },
        {
          name: 'shipped_customer_id',
          isShow: true,
          label: this.$t("global.field.customer"),
          type: 'value-help-v2',
          placeholder: `${this.$t("global.form.select")} ${this.$t("global.field.customer")}`,
          trackBy: 'id',
          displayedBy: 'name',
          listGetter: Customer.get,
          multiple: true,
          tableFields: [
            {
              label: this.$t("global.field.name"),
              key: 'name',
              isSortable: true,
            },
          ],
        },
        {
          name: 'vendor_id',
          isShow: hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']),
          label: 'Vendor',
          type: 'value-help-v2',
          placeholder: `${this.$t("global.form.select")} Vendor`,
          trackBy: 'id',
          displayedBy: 'name',
          listGetter: Vendor.get,
          multiple: true,
          tableFields: [
            {
              label: this.$t("global.field.name"),
              key: 'name',
              isSortable: true,
            },
          ],
        },
        {
          name: 'origin_address_id',
          isShow: true,
          label: this.$t("global.field.originAddress"),
          type: 'value-help-v2',
          placeholder: `${this.$t("global.form.select")} ${this.$t("global.field.originAddress")}`,
          trackBy: 'id',
          displayedBy: 'name',
          listGetter: Address.get(),
          multiple: true,
          tableFields: [
            {
              label: this.$t("global.object.locationName"),
              key: 'name',
              isSortable: true,
              isRedirectable: true,
            },
            {
              label: this.$t("global.object.city"),
              key: 'city',
              isSortable: true,
              isRedirectable: true,
            },
          ],
        },
        {
          name: 'destination_address_id',
          isShow: true,
          label: this.$t("global.field.destinationAddress"),
          type: 'value-help-v2',
          placeholder: `${this.$t("global.form.select")} ${this.$t("global.field.destinationAddress")}`,
          trackBy: 'id',
          displayedBy: 'name',
          listGetter: Address.get(),
          multiple: true,
          tableFields: [
            {
              label: this.$t("global.object.locationName"),
              key: 'name',
              isSortable: true,
              isRedirectable: true,
            },
            {
              label: this.$t("global.object.city"),
              key: 'city',
              isSortable: true,
              isRedirectable: true,
            },
          ],
        },
        {
          type: 'range-input',
          isShow: true,
          label: this.$t("global.field.totalWeight"),
          min: {
            name: 'load_weight_min',
            label: this.$t("global.field.minimum"),
            type: 'number',
            validation: 'bail|number|min:0,value',
            suffix: 'Kg',
            'validation-behavior': 'live',
          },
          max: {
            name: 'load_weight_max',
            label: this.$t("global.field.maximum"),
            type: 'number',
            validation: 'bail|number|min:0,value',
            suffix: 'Kg',
            'validation-behavior': 'live',
          },
        },
        {
          type: 'range-input',
          isShow: true,
          label: 'Total Volume',
          min: {
            name: 'load_volume_min',
            label: this.$t("global.field.minimum"),
            type: 'number',
            validation: 'bail|number|min:0,value',
            suffix: 'Cbm',
            'validation-behavior': 'live',
          },
          max: {
            name: 'load_volume_max',
            label: this.$t("global.field.maximum"),
            type: 'number',
            validation: 'bail|number|min:0,value',
            suffix: 'Cbm',
            'validation-behavior': 'live',
          },
        },
      ]
    }
  }
}
